import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../../redux/store'

import {
  EMPTY_STRING
} from '../components/global';

// Define a type for the slice state
interface MembershipState {
  searchText: string,
  householdSaved: boolean,
  memberSaved: boolean
}

// Define the initial state using that type
const initialState: MembershipState = {
  searchText: EMPTY_STRING,
  householdSaved: false,
  memberSaved: false
}

export const membershipSlice = createSlice({
  name: 'membership',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText += action.payload;
    },
    setHouseholdSaved: (state, action: PayloadAction<string>) => {
      state.householdSaved = action.payload;
    },
    setMemberSaved: (state, action: PayloadAction<boolean>) => {
      state.memberSaved = action.payload;
    }
  }
})

export const { setSearchText, setHouseholdSaved, setMemberSaved } = membershipSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const getHouseholdSaved = (state: RootState) => state.membership.householdSaved;
export const getMemberSaved = (state: RootState) => state.membership.memberSaved;

export default membershipSlice.reducer;